import React from 'react'

import Select from '@/components/forms/Select'
import { FormField } from '@/components/forms/FormField'
import { TextInput } from '@/components/forms/TextInput'

// Step 3 — the agent's own user account. The agent *is* a user row
// (ai_agent = true); it's created fresh on Continue in the chosen org. Fields
// start empty and are entered by the operator — we don't prefill from, or reuse,
// any existing user. The Playbook lands on users.config_cid, which voice-agents
// reads back for post-call processing.
export const AgentUserStep = ({
  username,
  firstName,
  lastName,
  configCid,
  playbookOptions,
  playbooksLoading,
  onChange,
}) => {
  return (
    <div className="create-agent__step" data-testid="agent-user-step">
      <h2>Agent identity</h2>
      <p className="create-agent__hint">
        The agent gets its own user in the organization you picked. Name it and choose a playbook —
        the user is created when you continue.
      </p>

      <div className="field-stack">
        <FormField>
          <label htmlFor="agent-username">Username</label>
          <TextInput
            id="agent-username"
            value={username}
            onChange={(event) => onChange('username', event.target.value)}
          />
          <div className="form-caption">The agent&apos;s login handle.</div>
        </FormField>
        <FormField>
          <label htmlFor="agent-first-name">First name</label>
          <TextInput
            id="agent-first-name"
            value={firstName}
            onChange={(event) => onChange('firstName', event.target.value)}
          />
        </FormField>
        <FormField>
          <label htmlFor="agent-last-name">Last name</label>
          <TextInput
            id="agent-last-name"
            value={lastName}
            onChange={(event) => onChange('lastName', event.target.value)}
          />
        </FormField>
        <FormField>
          <label htmlFor="agent-playbook">Playbook</label>
          <Select
            inputId="agent-playbook"
            options={playbookOptions}
            value={configCid}
            loading={playbooksLoading}
            isClearable={false}
            placeholder="Select a playbook…"
            onChange={(option) => onChange('configCid', option?.value ?? null)}
          />
          <div className="form-caption">
            The agent&apos;s playbook — drives its post-call processing.
          </div>
        </FormField>
      </div>
    </div>
  )
}
